<template>
  <div class="appHouseholdManage">
    <div class="filters">
      <el-form :inline="true">
        <!-- 选择日期 
        <el-form-item :label="$t('lang.lab_RegTime')">
          <el-date-picker
            v-model="datevalues"
            type="daterange"
            :range-separator="$t('lang.lab_to')"
            :start-placeholder="$t('lang.lab_startDate')"
            :end-placeholder="$t('lang.lab_endDate')"
            value-format="timestamp"
          ></el-date-picker>
        </el-form-item>-->
        <!-- 选择楼号 -->
        <el-form-item>
          <el-select v-model="floorid" @change="selectUnit">
            <el-option key :label="$t('lang.lab_floorName')" value=''></el-option>
            <el-option
              v-for="(item,index) in floorList"
              :key="index"
              :value="item.id"
              :label="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 选择单元号 -->
        <el-form-item>
          <el-select v-model="unitid" @change="selectRoom">
            <el-option key :label="$t('lang.lab_unitName')" value=''></el-option>
            <el-option
              v-for="(item,index) in unitList"
              :key="index"
              :value="item.id"
              :label="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 选择房间号 -->
        <el-form-item>
          <el-select v-model="roomid">
            <el-option key :label="$t('lang.lab_roomName')" value=''></el-option>
            <el-option
              v-for="(item,index) in roomList"
              :key="index"
              :value="item.id"
              :label="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 身份 -->
        <el-form-item>
          <el-select
            class="select"
            v-model="user"
            :placeholder="$t('lang.APPHOUSEHOLDMANAGE.USERTYPE[0].label')">
              <el-option
              v-for="item in Identitys"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              ></el-option>
          </el-select>
        </el-form-item>
          <!-- 标签 -->
        <!-- <el-form-item>
          <el-select
            class="select"
            v-model="tag"
            :placeholder="$t('lang.APPHOUSEHOLDMANAGE.TAGS[0].label')">
              <el-option
              v-for="item in tags"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              ></el-option>
          </el-select>
        </el-form-item> -->
        <!-- 关键字 -->
        <el-form-item>
          <el-input class="seachInput" v-model="keyword" :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_username')"></el-input>
        </el-form-item>       
          <el-button type="primary" @click="submit()">{{$t('lang.btn_search')}}</el-button>
      </el-form>
    </div>
    <el-card>
      <el-table :data="tableData" class="wid100" :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109" :row-class-name="tableRowClassName" @selection-change="handleSelectionChange">
        <!-- checkbox -->
        <el-table-column type="selection" width="55" v-if="appHouseholdManageListcheckbox"></el-table-column>
        <!-- 序号 -->
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px"></el-table-column>
        <!-- 用户名 -->
        <el-table-column prop="nickName" :label="$t('lang.lab_username')"></el-table-column>
        <!-- 手机 -->
        <el-table-column prop="mobile" :label="$t('lang.lab_phone')"></el-table-column>
        <!-- 小区 -->
        <el-table-column prop="garden.name" :label="$t('lang.lab_village')"></el-table-column>
        <!-- 楼号 -->
        <el-table-column prop="garden.grids.houseName" :label="$t('lang.lab_buildingnum')"></el-table-column>
        <!-- 单元号 -->
        <el-table-column prop="garden.grids.unitName" :label="$t('lang.lab_unitnum')"></el-table-column>
        <!-- 房间号 -->
        <el-table-column prop="garden.grids.roomName" :label="$t('lang.lab_roomnum')"></el-table-column>
        <!-- 身份 -->
        <!-- <el-table-column prop="garden.userType" :label="$t('lang.lab_identitynum')">
          <template slot-scope="scope">
            <span
              v-if="scope.row.garden.userType === 1"
            >{{$t('lang.APPHOUSEHOLDMANAGE.USERTYPE[1].label')}}</span>
            <span
              v-if="scope.row.garden.userType === 2"
            >{{$t('lang.APPHOUSEHOLDMANAGE.USERTYPE[2].label')}}</span>
            <span
              v-if="scope.row.garden.userType === 3"
            >{{$t('lang.APPHOUSEHOLDMANAGE.USERTYPE[3].label')}}</span>
          </template>
        </el-table-column>   -->
        <!-- 人员名称 -->
        <el-table-column prop="waName" :label="$t('lang.lab_userName1')"></el-table-column>
        <!-- 人像所有者（识别主体）guid -->
        <el-table-column prop="admitGuid" :label="$t('lang.lab_admitGuid')"></el-table-column>
        <!-- 操作 -->
        <el-table-column prop="operation" :label="$t('lang.lab_operation')"
          :width="require('@/config/enum').opr_width3">
            <template slot-scope="scope">
              <el-button class="orange" @click="auth(scope.row)" >人像授权</el-button>
            </template>
          </el-table-column>
      </el-table>
      <!-- 添加页码 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount"/>
    </el-card>
    <el-dialog :title=title :visible.sync="isPopupPage" :close-on-click-modal="false" center top="130px" width="600px"
				@closed="handleDialogClosed">
        <el-form :model="diaForm" :rules="rules" ref="diaForm" :label-width="require('@/config/enum').c_ws8" :label-suffix="require('@/config/enum').c_colon">
            <el-form-item :label="$t('lang.lab_userName1')" prop="name">
              <el-input :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_userName1')" v-model="diaForm.name"></el-input>
            </el-form-item>
            <el-form-item :label="$t('lang.lab_waPhone')" prop="phone">
              <el-input :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_waPhone')" v-model="diaForm.phone"></el-input>
            </el-form-item>
            <el-form-item :label="$t('lang.resourRemark')" prop="tag">
              <el-input :placeholder="$t('lang.lab_please_Input')+$t('lang.resourRemark')" v-model="diaForm.tag"></el-input>
            </el-form-item>            
        </el-form>
        <div slot="footer" class="dialog-footer">
              <el-button @click="clear('diaForm')">{{$t('lang.btn_rest')}}</el-button>
              <el-button type="primary" @click="save('diaForm')">{{$t('lang.btn_save')}}</el-button>
            </div>
    </el-dialog>
  </div>
</template>

<script>
// 引入富文本title汉字
import { excelDownload } from '../../../config/download.js'
/**
 *@ClassName:appHouseholdManage
 *@Description:app住户管理
 *@author:李斌
 *@Copyright:格众科技
 *@date:2020-03-16
 */
import { mapGetters } from 'vuex'

  export default {
    name: '/manage/main.woUserAuth',
    data() {
      return {
      multipleSelection: [], // 多选框
      datevalues: [], // 开始结束时间绑定值
      floorid: '', // 楼层绑定值
      floorList: [], // 楼层下拉列表
      unitid: '', // 单元绑定值
      unitList: [], // 单元下拉列表
      roomid: '', // 房间绑定值
      roomList: [], // 房间下拉列表
      user: '0', // 身份
      tag: '0', // 标签
      keyword: '', // 手机或序号内容input
      pageCount: 0, // 总页数
      pageNo: 1, // 第几页
      pageSize: 10, // 每页显示数
      tableData: [], // 列表数组
      type: 1, // 楼号单元号房间号区分
      parentId: '',
      title: '', // 弹框显示的标题
      isPopupPage: false, // 弹框的显示控制
      diaForm: {
          userId: '',
					name: '',
          phone: '',
					tag: ''
				},
        rules: {
					name: [{
						required: true,
						message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_userName1'),
						trigger: 'blur'
					}],
					phone: [{
						required: true,
						message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_waPhone'),
						trigger: 'blur'
					}]
				},
      Identitys: this.$i18n.t('lang.APPHOUSEHOLDMANAGE.USERTYPE'), // 身份列表
      tags: this.$i18n.t('lang.APPHOUSEHOLDMANAGE.TAGS'), // 标签列表
      appHouseholdManageListcheckbox: require('@/config/enum').appHouseholdManageListcheckbox, // 是否隐藏复选框
      }
    },
    created() {
      // 初始化
      this.topics()
      // 获取楼号
      this.gardenGrids(this.gardenId)
    },
    activated() {
      // 初始化
      this.topics()
      // 获取楼号
      this.gardenGrids(this.gardenId)
    },
    computed: {
      ...mapGetters(['gardenId'])
    },
    // 监听改变小区编号
    watch: {
      gardenId: function (newFlag, oldFlag) {
        this.gardenChange()
      }
    },
    methods: {
      clear(diaForm) {
				this.$refs[diaForm].resetFields()
				this.diaForm.userId = ''
				this.diaForm.name = ''
				this.diaForm.phone = ''
        this.diaForm.tag = ''
				setTimeout(() => {
					this.$refs[diaForm].clearValidate()
				}, 0)
			},
      save(diaForm) {
        this.$refs[diaForm].validate((valid) => {
          if (valid) {
              let params = {
								gardenId: this.gardenId,
								userId: this.diaForm.userId,
								name: this.diaForm.name,
								phone: this.diaForm.phone,
								tag: this.diaForm.tag
							}
              let loading = this.$loading()
              this.$post(`/woAdmit`, params).then(
								res => {
									loading.close()
									// if (res && res.errCode === 0) {
									this.$message.success(this.$i18n.t('lang.lab_save_success'))
									this.isPopupPage = false
                  this.pageNo = 1
									this.topics()
									// }
								},
								error => {
									loading.close()
									this.$message.error(error)
								}
							)
          } else {
							return false
					}
        })
      },
        // ID序号功能
      indexMethod(index) {
        return (this.pageNo - 1) * this.pageSize + index + 1
      },
      // 列表斑马线
      tableRowClassName({ row, rowIndex }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      // 添加多选框
      handleSelectionChange(val) {
        this.multipleSelection = val
      },
      // 表格下载
      excelDownloadClick() {
        if (navigator.onLine) {
          // Excel表头
          const tHeader = [
            this.$i18n.t('lang.lab_username'),
            this.$i18n.t('lang.lab_phone'),
            this.$i18n.t('lang.lab_village'),
            this.$i18n.t('lang.lab_buildingnum'),
            this.$i18n.t('lang.lab_unitnum'),
            this.$i18n.t('lang.lab_roomnum'),
            this.$i18n.t('lang.lab_identitynum'),
            this.$i18n.t('lang.lab_tags'),
          ]
          // 对应table数据的列字段名
          let newArr = []
          let userType = ''
          let houseName = ''
          let unitName = ''
          let roomName = ''
          if (this.tableData.length > 0) {
            for (let i = 0; i < this.tableData.length; i++) {
              // 判断楼号单元房间号是否存在
              if (this.tableData[i].garden.grids) {
                houseName = this.tableData[i].garden.grids.houseName
                unitName = this.tableData[i].garden.grids.unitName
                roomName = this.tableData[i].garden.grids.roomName
              }
              // 判断身份
              if (this.tableData[i].garden.userType === 1) {
                userType = this.$i18n.t('lang.APPHOUSEHOLDMANAGE.USERTYPE[1].label')
              } else if (this.tableData[i].garden.userType === 2) {
                userType = this.$i18n.t('lang.APPHOUSEHOLDMANAGE.USERTYPE[2].label')
              } else if (this.tableData[i].garden.userType === 3) {
                userType = this.$i18n.t('lang.APPHOUSEHOLDMANAGE.USERTYPE[3].label')
              }
              newArr.push({
                'nickName': this.tableData[i].nickName,
                'mobile': this.tableData[i].mobile,
                'garden.name': this.tableData[i].garden.name,
                'garden.grids.houseName': houseName,
                'garden.grids.unitName': unitName,
                'garden.grids.roomName': roomName,
                'garden.userType': userType,
                'tag': this.tableData[i].tag
              })
            }
          }
          const filterVal = ['nickName', 'mobile', 'garden.name', 'garden.grids.houseName', 'garden.grids.unitName', 'garden.grids.roomName', 'garden.userType', 'tag'] 
          excelDownload(tHeader, filterVal, newArr, this.$i18n.t('lang.lab_appUsermanagement'))
        } else {
          this.$message.error(this.$i18n.t('lang.lab_Online'))
        }
      },
      // 监听关闭dialog
			handleDialogClosed() {
				this.$refs.diaForm.resetFields()
				this.diaForm.name = ''
        this.diaForm.phone = ''
        this.diaForm.tag = ''
			},
      // 改变小区
      gardenChange() {
        this.floorid = ''
        this.topics()
        this.unitid = ''
        this.roomid = ''
        this.unitList = ''
        this.roomList = ''
        this.type = 1
        this.gardenGrids(this.gardenId)
      },
      // 获取楼号单元号房间号
      gardenGrids(parentId) {
        let loading = this.$loading()
        this.$get(`/gardenGrids?type=${this.type}&parentId=${parentId}&pageNo=1&pageSize=999`).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              if (this.type === 1) {
                this.floorList = res.list
              } else if (this.type === 2) {
                this.unitList = res.list
                this.roomList = ''
                if (this.floorid === '') {
                  this.unitList = ''
                  this.roomList = ''
                }
              } else if (this.type === 3) {
                this.roomList = res.list
                if (this.unitid === '') {
                  this.roomList = ''
                }
              }
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      topics() {
        var startTs = ''
        var endTs = ''
        if (this.datevalues != null) {
          if (this.datevalues.length > 0) {
            startTs = this.datevalues[0]
            endTs = this.datevalues[1]
          }
        }
        let loading = this.$loading()
        this.$get(
          `/usersWo?pageNo=${this.pageNo}&pageSize=${this.pageSize}&gardenId=${this.gardenId}&houseId=${this.floorid}&unitId=${this.unitid}&roomId=${this.roomid}&userType=${this.user}&woKey=${this.keyword}&tagId=${this.tag}&startTs=${startTs}&endTs=${endTs}&woIsAdmit=1`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.tableData = res.list
              this.pageCount = res.pageCount
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      change(row) {
        this.diaForm.userId = row.id
        this.diaForm.phone = row.userName
        this.title = this.$i18n.t('lang.btn_addWoAdmit')
        this.isPopupPage = true
				// this.$refs.diaForm.clearValidate()
      },
      del(row) {
        let loading = this.$loading()
        let params = {
              garden: this.gardenId,
              admitGuid: row.admitGuid
            }
        this.$confirm(
          this.$i18n.t('lang.lab_isdelete'),
          this.$i18n.t('lang.lab_prompt'),
          {
            confirmButtonText: this.$i18n.t('lang.btn_confirm'),
            cancelButtonText: this.$i18n.t('lang.btn_cancel'),
            type: 'warning'
          }
        ).then(() => {
            this.$delete(`woAdmit/` + row.waId, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message({
                    type: 'success',
                    message: this.$i18n.t('lang.lab_del_success')
                  })
                  this.pageNo = 1
                  this.topics()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          }).catch(() => {
            loading.close()
            this.$message({
              type: 'info',
              message: this.$i18n.t('lang.lab_del_can')
            })
          })
      },
      // 业主画像
      goPortrait(row) {
        console.log(row)
        this.$router.push({ name: 'appHouseholdPortrait', query: { row: row } })
      },
      // 提交
      submit() {
        this.pageNo = 1
        this.topics()
      },
      // 通过楼层选择单元号
      selectUnit() {
        this.type = 2
        this.gardenGrids(this.floorid)
        this.unitid = ''
        this.roomid = ''
      },
      // 通过单元选择房间号
      selectRoom() {
        this.type = 3
        this.gardenGrids(this.unitid)
        this.roomid = ''
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNo = val
        this.topics()
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNo = 1
        this.pageSize = val
        this.topics()
      },
      // 人像授权
      auth(row) {
        this.$router.push({ name: 'woAppAuthHouseholdManageDetail', query: { row: row } })
      }
    }
  }
</script>

<style lang= 'scss'>
</style>